import API from '@/api';
const Recommendation = API.get('Recommendation');

export default ({
  namespaced: true,
  state: {
    id: null,
    point_of_care: '',
    time_to_treat: '',
    recommended_action: '',
    record_type: '',
    created_on: '',
    recommendation_index: '',
    recommendations: [],
    removed_items: []
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  getters: {
    point_of_care: state => state.point_of_care,
    time_to_treat: state => state.time_to_treat,
    recommended_action: state => state.recommended_action,
    record_type: state => state.record_type,
    recommendations: state => state.recommendations,
    removed_items: state => state.removed_items,
    created_on: state => state.created_on,
    recommendation_index: state => state.recommendation_index,
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  mutations: {
    updatePointOfCare(state, point_of_care) {
      state.point_of_care = point_of_care
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    updateTimeToTreat(state, time_to_treat) {
      state.time_to_treat = time_to_treat
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    updateAction(state, recommended_action) {
      state.recommended_action = recommended_action
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    add(state) {

      let recommendation_index = null;
      if(state.recommendations[state.recommendations.length - 1]) {
        recommendation_index = state.recommendations[state.recommendations.length - 1].recommendation_index + 1;
      } else {
        recommendation_index = 0;
      }

      var recommendation = {
        id: null,
        point_of_care: state.point_of_care,
        time_to_treat: state.time_to_treat,
        recommended_action: state.recommended_action,
        created_on: null,
        record_type: "current",

        // work around with pagination issue
        recommendation_index
      }
      state.recommendations.push(recommendation)
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    clear(state) {
      state.id = null
      state.point_of_care = ''
      state.time_to_treat = ''
      state.recommended_action = ''
      state.record_type = ''
      state.recommendation_index = ''
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    edit(state) {
      var recommendation = {
        id: state.id,
        point_of_care: state.point_of_care,
        time_to_treat: state.time_to_treat,
        recommended_action: state.recommended_action,
        record_type: state.record_type,
        recommendation_index: state.recommendation_index
      }
      state.recommendations.splice(state.activeIndex, 1, recommendation);
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setActive(state, index) {
      // work around with pagination issue
      var target = state.recommendations.findIndex( recommendation => recommendation.recommendation_index === index );
      var recommendation = state.recommendations[target];

      console.log(recommendation);
      state.id = recommendation.id;
      state.point_of_care = recommendation.point_of_care;
      state.time_to_treat = recommendation.time_to_treat;
      state.recommended_action = recommendation.recommended_action;
      state.record_type = recommendation.record_type;
      state.recommendation_index = recommendation.recommendation_index

      state.activeIndex = index;
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    remove(state) {
      var index = state.activeIndex
      var target = state.recommendations.findIndex( recommendation => recommendation.recommendation_index === index );


      var item = state.recommendations[target]
      if (item.id !== null)
        state.removed_items.push(item)
      state.recommendations.splice(target, 1);
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    loadSavedData(state, recommendations) {
      state.recommendations = [];

      console.log("recommendations from cases");
      console.log(recommendations);

      recommendations.forEach(async (recommendation, index) => {
        const data = {
          id:                     recommendation.id,
          point_of_care:          recommendation.point_of_care,
          time_to_treat:          recommendation.time_to_treat,
          recommended_action:     recommendation.recommended_action,
          created_on:             recommendation.pms_created_on,
          record_type:            recommendation.record_type,

          // work around for pagination issue
          recommendation_index: index,
        }

        state.recommendations.push(data);
      });
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    clearStoreData(state) {
      state.id = null;
      state.point = '';
      state.time_to_treat = '';
      state.record_type = '';
      state.recommended_action = '';
      state.recommendation_index = '';
      state.recommendations = [];
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    setRecommendationId(state, {index, id}) {
      state.recommendations[index].id = id
    }
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  actions: {
    async save({ commit, getters }, {case_id, consult_id}) {
      getters.recommendations.forEach(async (recommendation, key) => {
        const payload = {
          point_of_recommendation: recommendation.point,
          time_to_treat: recommendation.time,
          recommended_action: recommendation.recommended_action
        }
        
        let response;
        if (recommendation.id == null) {
          payload.patient_case_id = case_id
          payload.case_consultation_id = consult_id
          response = await Recommendation.create(payload);
          console.log("[recommendation/save]", response, payload, key, response.data.id);
          // fix to avoid duplicate saved data on second save
          commit('setRecommendationId', { index: key, id: response.data.id })
        } else {
          response = await Recommendation.update(recommendation.id, payload);
          console.log("[recommendation/update]", response, recommendation.point, recommendation.id);
        }
      });

      // delete removed items
      if (getters.removed_items.length) {
        getters.removed_items.forEach(async recommendation => {
          let response = await Recommendation.delete(recommendation.id);
          console.log("[recommendation/delete_removed_items]", response);
        });
      }
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    async compiled_recommendations({ getters }, {case_id}) {
      let compiled_recommendations = [];

      getters.recommendations.forEach(async (recommendation) => {
        if(recommendation.record_type == "current") {
          let payload = {
            id:                         recommendation.id,
            point_of_care:              recommendation.point_of_care,
            time_to_treat:              recommendation.time_to_treat,
            recommended_action:         recommendation.recommended_action,
            record_type:                recommendation.record_type,
            patient_case_id:            case_id
          }

          compiled_recommendations.push(payload);
        }
      });

      return compiled_recommendations;
    },

    /* ################################################## METHOD SEPARATORS ################################################## */

    async delete(state, recommendations) {
      if (recommendations) {
        recommendations.forEach(async recommendation => {
          let response = await Recommendation.delete(recommendation.id);
          console.log("[recommendation/delete]", response);
        });
      }
    },
  }
})